export class UpdateReservationPhoneNumberNotRequiredTransactionsError extends Error {
  static create(errorMessage) {
    return new UpdateReservationPhoneNumberNotRequiredTransactionsError(errorMessage)
  }
}
